import { useRequiredContext } from "@redotech/react-util/context";
import { useTriggerLoad } from "@redotech/react-util/load";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import {
  ReloadTeamContext,
  TeamContext,
} from "@redotech/redo-merchant-app-common/team";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

export function useStartSuppliesShopping(
  handleComplete: () => void | Promise<void>,
) {
  const team = useContext(TeamContext);
  const reloadTeam = useContext(ReloadTeamContext);
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);
  const navigate = useNavigate();

  return useTriggerLoad(async () => {
    await rpcClient.enableSuppliesStorefront({});
    reloadTeam?.();
    if (team) {
      navigate(`/stores/${team._id.toString()}/redo-supplies`);
    }
    await handleComplete();
    return null;
  });
}
